<template>
  <el-col :span="12" :offset="6">
    <changepassform @success="onSuccess" />
  </el-col>
</template>

<script>
import changePassForm from './ChangePassForm.vue';
export default {
  name: 'change-password',
  methods: {
    onSuccess(){
      this.$router.push({ path: '/sites' });
    }
  },
  components: {
    'changepassform' : changePassForm
  }
}
</script>



// WEBPACK FOOTER //
// ChangePassword.vue?56b37c8e